import { useEffect, useState } from 'react';
import { useThemeStatics } from './useThemeConfig';

const useChangeBackground = (min = 1, max = 3, delaySeconds = 5) => {
	const staticConfig = useThemeStatics();
	// const { homeUrl, imageFromHomeUrl, bannerList, bannerMobileList, logo } = staticConfig;
	const { homeUrl, imageFromHomeUrl, bannerList } = staticConfig;

	const range = max - min + 1;

	const [state, setState] = useState(1);
	const updateN = () => {
		const newN = state === range ? 1 :  state + 1;
		setState(newN);
	};
	useEffect(() => {
		const timeoutId = setTimeout(() => {
				updateN();
            }, delaySeconds * 1000)

            return () => clearTimeout(timeoutId);
	},[state]); // eslint-disable-line react-hooks/exhaustive-deps

	const auxNumber = state + range;
	const imageNumber = auxNumber > bannerList.length ? auxNumber % bannerList.length : state - 1; 
	const prefix = imageFromHomeUrl ? homeUrl : '';
	const url = prefix + bannerList[imageNumber];
	
	return url;
};

export default useChangeBackground;